// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7be9a925","239":"b1b94f40","453":"cb30bfe3","455":"6dc2a1c7"}[chunkId] + ".chunk.js";
};